import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import { Link } from "react-router-dom";
import service from "../../assets/images/banner/ai-rpa.png";
import basebg from "../../assets/images/resource/base.png";
import g1 from "../../assets/images/resource/ai-rpa.png";
import videoSource from "../../assets/videos/vdo-1.mp4";
import AI_RPA_Usecases from "../AI-RPA-Usecases";

import IntelligentAutomation from "../IntelligentAutomation";

const DigitalMarketing = () => {
  pageTitle("RPA");
  
  const servicesData = [
    { id: 1, title: "AI WhatsApp Agents", slug: "/Whatsapp-estore" },
    { id: 2, title: "RPA", slug: "/RPA-AI" },
    { id: 3, title: "Data & Analytics", slug: "/Data-Analytics" },
    // { id: 4, title: "Web Development", slug: "/Web-Development" },
    // { id: 5, title: "Digital Consulting", slug: "/digital-consultancy" },
    // { id: 6, title: "Data Science", slug: "/Data-Science" },
  ];

  // const renderServices = () =>
  //   servicesData.map((service) => (
  //     <li
  //       key={service.id}
  //       className={service.slug === "/content-marketing" ? "active" : ""}
  //     >
  //       <Link to={service.slug}>{service.title}</Link>
  //     </li>
  //   ));

  return (
    <>
      <HeaderOne />

      <section className="page__title p_relative">
        <div
          className="bg-layer"
          style={{
            backgroundImage: `url(${g1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
        <div className="auto-container">
          <div className="content__box p_relative"></div>
        </div>
      </section>

      {/* <div className="service__details p_relative">
        <div className="auto-container">
          <div className="row service__details__row d-flex flex-wrap"> */}
            {/* Right Image */}
            {/* <div className="col-xl-8 col-lg-12 col-md-12 service__right">
              <figure>
                <img src={service} alt="" className="service-images" />
              </figure>
            </div> */}

            {/* Left Sidebar */}
            {/* <div className="col-xl-4 col-lg-6 col-md-12 service__details__left">
              <div
                className="sidebar__widget_network"
                style={{ backgroundImage: `url(${basebg})` }}
              >
                <h3 style={{ paddingBottom: "20px" }}>RPA</h3>
                <video controls style={{ width: "100%", marginRight: "10px" }}>
                  <source src={videoSource} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div> */}

      {/* Full Width Paragraph */}
    <div className="container">
            <div className=" service__full__content">
              <h2>Robotic Process Automation (RPA) Platform Services</h2>

              <p>
                RPA empower organizations to accelerate innovation and enhance
                operational efficiency by automating critical business
                processes. Automation reduces the burden of repetitive, manual
                tasks, enabling employees to focus on higher-value, strategic
                initiatives while intelligent systems operate seamlessly in the
                background.
              </p>

              <p className="siw-rpa-desc">
                By leveraging robotic process automation (RPA), artificial
                intelligence, machine learning, natural language processing, and
                computer vision, <span className="SiW">SiW</span> delivers
                intelligent automation consulting services that support
                end-to-end digital transformation. With over seven years of
                technology consulting experience across multiple industries,{" "}
                <span className="SiW">SiW</span> combines deep expertise and
                proven resources to help organizations digitize, optimize, and
                scale their operations.
              </p>
            </div>

            {/* Intelligent Automation */}
            <div className="col-12 IA">
              <IntelligentAutomation />
            </div>
            <div className="col-12 IA pt-2 pt-md-0">
              <AI_RPA_Usecases />
        </div>
        </div>
          {/* </div>
        </div>
      </div> */}

      <FooterOne />

      {/* Responsive Ordering CSS */}
      <style>{`
        @media (max-width: 991px) {
          .service__details__row {
            display: flex;
            flex-direction: column;
          }
          .service__right { order: 1; }
          .IA { order: 2; margin: 20px 0; }
          .service__details__left { order: 3; }
        }

        @media (min-width: 992px) {
          .service__details__row {
            flex-direction: row;
          }
          .service__right, .IA, .service__details__left {
            order: initial;
            margin: 0;
           
          }
            .service__details__left {
              height:50vh;
            }
        }
      `}</style>
    </>
  );
};

export default DigitalMarketing;
